// @flow
// $FlowFixMe
import React from "react";
import type { RaceStatusEnum } from "@tvg/types/Race";
import { type NullaryFn } from "@tvg/types/Functional";
import { noop } from "lodash";
import MTP from "../../_atoms/MTP";
import Tag from "../../_atoms/Tag";
import {
  RaceLinkAbbrContainer,
  RaceLinkAbbrWrapper,
  TopContainer,
  PromoWrapper,
  RaceLabel
} from "./styled-components";

type Props = {
  mtp: number,
  mtpStatus: RaceStatusEnum,
  mtpPostTime: string,
  optedIn: boolean,
  inPromo: boolean,
  url: string,
  raceNumber: number,
  onClickCallback: NullaryFn<void>
};

const RaceLinkAbbr = ({
  mtp,
  mtpStatus,
  mtpPostTime,
  inPromo,
  optedIn,
  url,
  raceNumber,
  onClickCallback
}: Props) => (
  <RaceLinkAbbrContainer to={url} onClick={onClickCallback}>
    <RaceLinkAbbrWrapper>
      <TopContainer>
        <RaceLabel>Race {raceNumber}</RaceLabel>
        {inPromo && (
          <PromoWrapper>
            <Tag
              name="Promo"
              tagType={optedIn ? "OptedInTag" : "PromoTag"}
              isCollapsed
            />
          </PromoWrapper>
        )}
      </TopContainer>
      <MTP
        mtp={mtp}
        status={mtpStatus}
        postTime={mtpPostTime}
        isNewLayout
        isSmall
        mode="light"
        inline
        showDescription={false}
      />
    </RaceLinkAbbrWrapper>
  </RaceLinkAbbrContainer>
);

RaceLinkAbbr.defaultProps = {
  mtp: 0,
  mtpStatus: "O",
  mtpPostTime: new Date().toISOString(),
  inPromo: false,
  optedIn: false,
  url: "",
  raceNumber: 0,
  onClickCallback: noop
};

// $FlowFixMe - Cannot call React.memo because property memo is missing in object type
export default RaceLinkAbbr;
